import { authFetch } from './auth';
import {
  termsStatusSchema,
  termsAcceptResultSchema,
  type TermsStatus,
} from '../../shared/protocol';

/**
 * THU-115 — client half of the clickwrap gate.
 *
 * The versions and URLs shown to the user come from the SERVER's answer, not
 * from constants compiled into this bundle: a cached SPA and a freshly deployed
 * worker will otherwise disagree about what the current terms are, and the one
 * that matters is the one the record is written against.
 */

/** null = we could not ask (offline, 401). Callers treat null as "don't block". */
export async function fetchTermsStatus(): Promise<TermsStatus | null> {
  try {
    const res = await authFetch('/api/auth/terms');
    if (!res.ok) return null;
    const parsed = termsStatusSchema.safeParse(await res.json());
    return parsed.success ? parsed.data : null;
  } catch {
    return null;
  }
}

/** Records the agreement. Throws with the server's message on any failure —
 *  the user must never be told they agreed when nothing was written down. */
export async function acceptTerms(status: TermsStatus): Promise<void> {
  const res = await authFetch('/api/auth/terms/accept', {
    method: 'POST',
    body: JSON.stringify({
      termsVersion: status.termsVersion,
      privacyVersion: status.privacyVersion,
    }),
  });
  const raw: unknown = await res.json().catch(() => null);
  if (!res.ok) {
    const msg = (raw as { message?: string } | null)?.message;
    throw new Error(msg ?? 'We could not save that just now — try once more in a moment.');
  }
  if (!termsAcceptResultSchema.safeParse(raw).success) {
    throw new Error('We could not save that just now — try once more in a moment.');
  }
}
